// Shared client helper for the create-modal paperclip: read a batch of browser
// `File`s and link them to a just-created entity, via the one attachments upload
// endpoint. DRY — every create flow calls THIS after its create returns an id.

import { apiCall } from "./client";
import { attachments } from "./contracts/attachments";

function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result as string;
      // Strip the `data:<mime>;base64,` prefix — the route wants raw base64.
      resolve(result.slice(result.indexOf(",") + 1));
    };
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
}

/**
 * Upload + link `files` to the entity `(entityKind, entityId)`. No-ops on an
 * empty list. Returns the created attachment rows. Throws on a failed upload —
 * callers decide whether an attachment failure should surface (the entity itself
 * was already created).
 */
export async function attachFilesToEntity(
  entityKind: string,
  entityId: number,
  files: File[],
): Promise<{ id: number; filename: string; storage_ref: string }[]> {
  if (!files.length) return [];
  const encoded = await Promise.all(
    files.map(async (f) => ({
      name: f.name,
      mime: f.type || undefined,
      dataBase64: await fileToBase64(f),
    })),
  );
  const res = await apiCall(attachments.upload, {
    body: { entityKind, entityId, files: encoded },
  });
  return res.attachments;
}
